<div class="dev-tool-container" style="padding: 20px; font-family: sans-serif;">
  <h2 style="border-bottom: 1px solid #ccc; padding-bottom: 10px; margin-bottom: 20px;">Developer Administration</h2>

  <!-- Remap Brands to Existing IDs (Featured at Top) -->
  <div class="tool-card"
    style="border: 2px solid #0284c7; border-radius: 8px; padding: 20px; background-color: #f0f9ff; max-width: 600px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1); margin-bottom: 25px;">
    <h3 style="margin-top: 0; color: #0369a1; font-size: 1.25rem;">🔗 Remap Brands to Existing IDs (LFC & K Photolavie)</h3>
    <p style="color: #334155; margin-bottom: 15px; line-height: 1.5; font-size: 14px;">
      Resolves the existing Brand IDs for <strong>LFC</strong> (matching <em>LFC, LK, Life Four Cuts</em>) and <strong>K Photolavie</strong> in the brands collection, then updates all <code>company</code>, <code>stores</code>, <code>devices</code>, and <code>smrs_rates</code> documents to point directly to these existing brand IDs.
    </p>

    <button (click)="remapBrandsToExistingIds()" [disabled]="isRemappingBrands"
      style="padding: 12px 24px; font-size: 15px; cursor: pointer; background-color: #0284c7; color: white; font-weight: bold; border: none; border-radius: 6px; box-shadow: 0 2px 4px rgba(0,0,0,0.15);">
      <span *ngIf="isRemappingBrands">Remapping Brands...</span>
      <span *ngIf="!isRemappingBrands">🔗 Remap Brands to Existing IDs</span>
    </button>
  </div>

  <!-- Reassign Company Brand IDs (Explicit ID Mapping) -->
  <div class="tool-card"
    style="border: 2px solid #16a34a; border-radius: 8px; padding: 20px; background-color: #f0fdf4; max-width: 600px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1); margin-bottom: 25px;">
    <h3 style="margin-top: 0; color: #15803d; font-size: 1.25rem;">🏢 Reassign Company Brand IDs (LFC & K-Photo LaVie)</h3>
    <p style="color: #334155; margin-bottom: 12px; line-height: 1.5; font-size: 14px;">
      Reassigns companies in the <code>company</code> collection to their designated new brand IDs:
    </p>
    <ul style="color: #334155; font-size: 13px; line-height: 1.6; margin-bottom: 15px; padding-left: 20px;">
      <li><strong>LFC:</strong> <code>P3Q4LSohGvHglFtHu9OF</code> &rarr; <code>9wne793dXs1zI00AAmdk</code></li>
      <li><strong>K-Photo LaVie:</strong> <code>T0RdUUPStz2b979i3K4A</code> &rarr; <code>djrizY8FlIVsYK8vBN4t</code></li>
    </ul>

    <button (click)="reassignCompanyBrandIds()" [disabled]="isReassigningCompanyBrandIds"
      style="padding: 12px 24px; font-size: 15px; cursor: pointer; background-color: #16a34a; color: white; font-weight: bold; border: none; border-radius: 6px; box-shadow: 0 2px 4px rgba(0,0,0,0.15);">
      <span *ngIf="isReassigningCompanyBrandIds">Reassigning Companies...</span>
      <span *ngIf="!isReassigningCompanyBrandIds">🚀 Reassign Company Brand IDs</span>
    </button>
  </div>

  <div class="tool-card"
    style="border: 1px solid #ddd; border-radius: 8px; padding: 20px; background-color: #f9f9f9; max-width: 600px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
    <h3 style="margin-top: 0; color: #333;">Store Mapping Import</h3>

    <div class="description" style="margin-bottom: 20px; color: #555; line-height: 1.5;">
      <p><strong>What it does:</strong> This tool synchronizes Company and Store data from an Excel file. It ensures all
        companies and stores listed exist in the system and links stores to their respective companies.</p>
      <p><strong>Columns Processed:</strong> The import expects the header at Row 6 with columns: <code>회사이름</code>
        (Company Name) and <code>인생네컷 그룹 ID</code> (Store ID).</p>
      <p><strong>Update Process:</strong></p>
      <ol style="margin-top: 5px; padding-left: 20px;">
        <li><strong>Company Sync:</strong> Identifies unique company names and creates new company records if they don't
          exist.</li>
        <li><strong>Store Sync:</strong> Identifies unique store IDs. Creates new records if they don't exist, and
          restores previously soft-deleted stores.</li>
        <li><strong>Mapping:</strong> Updates each store record with the corresponding Company ID based on the company
          name provided.</li>
      </ol>
    </div>

    <input type="file" #storeMapInput hidden (change)="onStoreMapFileChange($event)" accept=".xlsx, .xls">
    <button (click)="storeMapInput.click()" [disabled]="isMapping"
      style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #007bff; color: white; border: none; border-radius: 4px;">
      <span *ngIf="isMapping">Importing...</span>
      <span *ngIf="!isMapping">Import Store Mapping</span>
    </button>
  </div>

  <!-- Frame Usage Backfill -->
  <div class="tool-card"
    style="border: 1px solid #ddd; border-radius: 8px; padding: 20px; background-color: #f9f9f9; max-width: 600px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); margin-top: 20px;">
    <h3 style="margin-top: 0; color: #333;">Data Migrations</h3>
    <p style="color: #555; margin-bottom: 15px;">Backfill Frame Usage Reports from past sessions.</p>

    <button (click)="previewBackfillFrameUsage()" [disabled]="isBackfillingFrames"
      style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #17a2b8; color: white; border: none; border-radius: 4px; margin-bottom: 15px; margin-right: 10px;">
      <span *ngIf="isBackfillingFrames && !hasPreviewedBackfill">Scanning...</span>
      <span *ngIf="!isBackfillingFrames || hasPreviewedBackfill">1. Preview Frame Usage Backfill</span>
    </button>

    <button *ngIf="hasPreviewedBackfill" (click)="executeBackfillFrameUsage()"
      [disabled]="isBackfillingFrames && hasPreviewedBackfill"
      style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #dc3545; color: white; border: none; border-radius: 4px; margin-bottom: 15px;">
      <span *ngIf="isBackfillingFrames">Writing...</span>
      <span *ngIf="!isBackfillingFrames">2. Execute Backfill ({{ backfillPreview.length }} updates)</span>
    </button>

    <div *ngIf="backfillPreview.length > 0" style="margin-bottom: 15px;">
      <h4 style="margin: 0 0 10px 0; font-size: 14px; color: #333;">Preview of Updates:</h4>
      <div
        style="background-color: #fff; border: 1px solid #ccc; padding: 10px; border-radius: 4px; max-height: 250px; overflow-y: auto; font-family: monospace; font-size: 12px; color: #333;">
        <table style="width: 100%; border-collapse: collapse;">
          <thead>
            <tr style="border-bottom: 1px solid #ccc; text-align: left;">
              <th style="padding: 4px;">Device</th>
              <th style="padding: 4px;">Month</th>
              <th style="padding: 4px;">FrameId</th>
              <th style="padding: 4px;">Theme/Group</th>
              <th style="padding: 4px;">Print Count (+n)</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of backfillPreview" style="border-bottom: 1px solid #eee;">
              <td style="padding: 4px;">{{ p.deviceId }}</td>
              <td style="padding: 4px;">{{ p.monthStr }}</td>
              <td style="padding: 4px;">{{ p.frameId }}</td>
              <td style="padding: 4px;">{{ p.themeId }} / {{ p.frameGroupId }}</td>
              <td style="padding: 4px; font-weight: bold; color: #28a745;">+{{ p.printCount }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div *ngIf="backfillLogs.length > 0"
      style="background-color: #1e1e1e; color: #d4d4d4; padding: 10px; border-radius: 4px; max-height: 200px; overflow-y: auto; font-family: monospace; font-size: 12px;">
      <div *ngFor="let log of backfillLogs">{{ log }}</div>
    </div>
  </div>

  <!-- Device brandId Backfill (AC-2) -->
  <div class="tool-card"
    style="border: 1px solid #0d6efd; border-radius: 8px; padding: 20px; background-color: #f8fafc; max-width: 650px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); margin-top: 20px;">
    <h3 style="margin-top: 0; color: #1e40af;">🏷️ Backfill Device brandId (to K-Photo LaVie)</h3>
    <p style="color: #475569; margin-bottom: 15px; font-size: 14px; line-height: 1.5;">
      Resolves and sets <code>brandId</code> to <strong>K-Photo LaVie</strong> for every device in <code>devices</code> missing a brand assignment (no devices are assigned to LFC).
      Provides a dry-run preview before commit; never overwrites existing <code>brandId</code>.
    </p>

    <div style="display: flex; gap: 10px; margin-bottom: 15px; flex-wrap: wrap;">
      <button (click)="previewBackfillDeviceBrands()" [disabled]="isBackfillingDeviceBrands"
        style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #2563eb; color: white; border: none; border-radius: 4px; font-weight: 600;">
        <span *ngIf="isBackfillingDeviceBrands && !hasPreviewedDeviceBrands">Scanning Devices...</span>
        <span *ngIf="!isBackfillingDeviceBrands || hasPreviewedDeviceBrands">1. Preview Missing brandId Backfill</span>
      </button>

      <button (click)="previewReassignAllDeviceBrands()" [disabled]="isBackfillingDeviceBrands"
        style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #7c3aed; color: white; border: none; border-radius: 4px; font-weight: 600;">
        <span>🔄 Preview Reassign ALL to K-Photo LaVie</span>
      </button>

      <button *ngIf="hasPreviewedDeviceBrands && deviceBrandPreview.length > 0" (click)="executeBackfillDeviceBrands()"
        [disabled]="isBackfillingDeviceBrands"
        style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #16a34a; color: white; border: none; border-radius: 4px; font-weight: 600;">
        <span *ngIf="isBackfillingDeviceBrands">Writing to Firestore...</span>
        <span *ngIf="!isBackfillingDeviceBrands">2. Execute Reassign / Backfill ({{ deviceBrandPreview.length }} devices)</span>
      </button>
    </div>

    <!-- Preview Table -->
    <div *ngIf="deviceBrandPreview.length > 0" style="margin-bottom: 15px;">
      <h4 style="margin: 0 0 10px 0; font-size: 14px; color: #1e293b;">Preview of Resolved Brands ({{ deviceBrandPreview.length }}):</h4>
      <div style="background-color: #fff; border: 1px solid #cbd5e1; padding: 10px; border-radius: 4px; max-height: 250px; overflow-y: auto; font-family: monospace; font-size: 12px; color: #334155;">
        <table style="width: 100%; border-collapse: collapse;">
          <thead>
            <tr style="border-bottom: 1px solid #cbd5e1; text-align: left;">
              <th style="padding: 4px;">Device ID</th>
              <th style="padding: 4px;">Store ID</th>
              <th style="padding: 4px;">Company</th>
              <th style="padding: 4px;">Resolved Brand</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of deviceBrandPreview" style="border-bottom: 1px solid #f1f5f9;">
              <td style="padding: 4px; font-weight: 600;">{{ item.deviceId }}</td>
              <td style="padding: 4px;">{{ item.storeId }}</td>
              <td style="padding: 4px;">{{ item.companyName }}</td>
              <td style="padding: 4px; color: #2563eb; font-weight: 600;">{{ item.brandName }} ({{ item.resolvedBrandId }})</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Unresolved Devices List -->
    <div *ngIf="unresolvedDevices.length > 0" style="margin-bottom: 15px;">
      <h4 style="margin: 0 0 10px 0; font-size: 14px; color: #b91c1c;">⚠️ Unresolved Devices ({{ unresolvedDevices.length }}) - Manual Fix Required:</h4>
      <div style="background-color: #fff1f2; border: 1px solid #fecdd3; padding: 10px; border-radius: 4px; max-height: 200px; overflow-y: auto; font-family: monospace; font-size: 12px; color: #9f1239;">
        <table style="width: 100%; border-collapse: collapse;">
          <thead>
            <tr style="border-bottom: 1px solid #fecdd3; text-align: left;">
              <th style="padding: 4px;">Device ID</th>
              <th style="padding: 4px;">Store ID</th>
              <th style="padding: 4px;">Reason</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of unresolvedDevices" style="border-bottom: 1px solid #ffe4e6;">
              <td style="padding: 4px; font-weight: 600;">{{ item.deviceId }}</td>
              <td style="padding: 4px;">{{ item.storeId }}</td>
              <td style="padding: 4px;">{{ item.reason }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Terminal Logs -->
    <div *ngIf="deviceBrandLogs.length > 0"
      style="background-color: #1e1e1e; color: #d4d4d4; padding: 10px; border-radius: 4px; max-height: 200px; overflow-y: auto; font-family: monospace; font-size: 12px;">
      <div *ngFor="let log of deviceBrandLogs">{{ log }}</div>
    </div>
  </div>

  <div class="tool-card"
    style="border: 1px solid #ddd; border-radius: 8px; padding: 20px; background-color: #f9f9f9; max-width: 600px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); margin-top: 20px;">
    <h3 style="margin-top: 0; color: #333;">Update Store Names</h3>
    <p style="color: #555; margin-bottom: 15px;">Upload an invoice Excel file to update 'storeName' in the 'stores'
      collection based on '지점 계정' (Store ID).</p>

    <input type="file" #storeNameInput hidden (change)="onUpdateStoreNamesFileChange($event)" accept=".xlsx, .xls">
    <button (click)="storeNameInput.click()" [disabled]="isUpdatingNames"
      style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #fd7e14; color: white; border: none; border-radius: 4px;">
      <span *ngIf="isUpdatingNames">Updating...</span>
      <span *ngIf="!isUpdatingNames">Update Store Names</span>
    </button>
  </div>

  <div class="tool-card"
    style="border: 1px solid #ddd; border-radius: 8px; padding: 20px; background-color: #f9f9f9; max-width: 600px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); margin-top: 20px;">
    <h3 style="margin-top: 0; color: #333;">Update Machine Countries</h3>
    <p style="color: #555; margin-bottom: 15px;">Upload an Excel file to add 'Country' field to 'machines' collection.
      (ID: machine_{{ '{' }}name{{ '}' }})</p>

    <input type="file" #machineCountryInput hidden (change)="onUpdateMachineCountriesFileChange($event)"
      accept=".xlsx, .xls">
    <button (click)="machineCountryInput.click()" [disabled]="isUpdatingMachineCountries"
      style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #6610f2; color: white; border: none; border-radius: 4px;">
      <span *ngIf="isUpdatingMachineCountries">Updating...</span>
      <span *ngIf="!isUpdatingMachineCountries">Update Machine Countries</span>
    </button>
  </div>

  <div class="tool-card"
    style="border: 1px solid #ddd; border-radius: 8px; padding: 20px; background-color: #f9f9f9; max-width: 600px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); margin-top: 20px;">
    <h3 style="margin-top: 0; color: #333;">Sync Store Device Counts</h3>
    <p style="color: #555; margin-bottom: 15px;">Scans all active photobooth terminals in 'devices', calculates the count of machines mapped to each store, and updates 'deviceCount' on the store documents in 'stores'. This enables User Portal and ERP queries to filter stores with active devices.</p>

    <button (click)="syncStoreMachineCounts()" [disabled]="isSyncingStoreMachineCounts"
      style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #0d6efd; color: white; border: none; border-radius: 4px;">
      <span *ngIf="isSyncingStoreMachineCounts">Syncing Device Counts...</span>
      <span *ngIf="!isSyncingStoreMachineCounts">Recalculate Store Device Counts</span>
    </button>
    <div *ngIf="storeMachineCountSyncResult" style="margin-top: 10px; font-size: 13px; color: #1e40af;">
      {{ storeMachineCountSyncResult }}
    </div>
  </div>

  <div class="tool-card"
    style="border: 1px solid #ddd; border-radius: 8px; padding: 20px; background-color: #f9f9f9; max-width: 600px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); margin-top: 20px;">
    <h3 style="margin-top: 0; color: #333;">Remove Legacy machineCount from Stores</h3>
    <p style="color: #555; margin-bottom: 15px;">Removes the redundant 'machineCount' field from all documents in the 'stores' collection via batch updates, leaving only the standard 'deviceCount' field.</p>

    <button (click)="removeMachineCountFromStores()" [disabled]="isRemovingMachineCounts"
      style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #dc3545; color: white; border: none; border-radius: 4px;">
      <span *ngIf="isRemovingMachineCounts">Removing machineCount...</span>
      <span *ngIf="!isRemovingMachineCounts">Remove machineCount from Stores</span>
    </button>
    <div *ngIf="removeMachineCountsResult" style="margin-top: 10px; font-size: 13px; color: #166534;">
      {{ removeMachineCountsResult }}
    </div>
  </div>

  <div class="tool-card"
    style="border: 1px solid #ddd; border-radius: 8px; padding: 20px; background-color: #f9f9f9; max-width: 600px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); margin-top: 20px;">
    <h3 style="margin-top: 0; color: #333;">Lookup Data Initialization</h3>
    <p style="color: #555; margin-bottom: 15px;">Initialize static lookup tables (e.g., Countries).</p>

    <div style="margin-bottom: 15px;">
      <label style="display: block; margin-bottom: 5px; font-weight: bold; color: #555;">Countries (Name:Code, comma
        separated):</label>
      <textarea [(ngModel)]="countryInput"
        style="width: 100%; height: 120px; padding: 8px; border: 1px solid #ccc; border-radius: 4px; box-sizing: border-box; font-family: monospace; resize: vertical;"></textarea>
    </div>

    <button (click)="initCountries()"
      style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #28a745; color: white; border: none; border-radius: 4px;">
      Initialize Countries
    </button>
  </div>

  <div class="tool-card"
    style="border: 1px solid #ddd; border-radius: 8px; padding: 20px; background-color: #f9f9f9; max-width: 600px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); margin-top: 20px;">
    <h3 style="margin-top: 0; color: #333;">Chart of Accounts Initialization</h3>
    <p style="color: #555; margin-bottom: 15px;">Initialize default Chart of Accounts data (Assets, Liabilities, Equity,
      Revenue, Expenses) into the 'chart_of_account' collection.</p>
    <button (click)="initChartOfAccounts()"
      style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #6f42c1; color: white; border: none; border-radius: 4px;">
      Initialize COA
    </button>
  </div>

  <div class="tool-card"
    style="border: 1px solid #ddd; border-radius: 8px; padding: 20px; background-color: #f9f9f9; max-width: 600px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); margin-top: 20px;">
    <h3 style="margin-top: 0; color: #333;">Roles Initialization</h3>
    <p style="color: #555; margin-bottom: 15px;">Initialize default Roles (admin, manager, user) into the 'roles'
      collection.</p>
    <button (click)="initRoles()"
      style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #17a2b8; color: white; border: none; border-radius: 4px;">
      Initialize Roles
    </button>
  </div>

  <div class="tool-card"
    style="border: 1px solid #ddd; border-radius: 8px; padding: 20px; background-color: #f9f9f9; max-width: 600px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); margin-top: 20px;">
    <h3 style="margin-top: 0; color: #333;">Migrate Brand LK to LFC</h3>
    <p style="color: #555; margin-bottom: 15px;">Update all company records in the database with brand "LK" to "LFC".
    </p>

    <button (click)="updateBrandLkToLfc()" [disabled]="isUpdatingBrand"
      style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #ffc107; color: #333; font-weight: bold; border: none; border-radius: 4px;">
      <span *ngIf="isUpdatingBrand">Updating...</span>
      <span *ngIf="!isUpdatingBrand">Migrate LK to LFC</span>
    </button>
  </div>

  <div class="tool-card"
    style="border: 1px solid #ddd; border-radius: 8px; padding: 20px; background-color: #f9f9f9; max-width: 600px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); margin-top: 20px;">
    <h3 style="margin-top: 0; color: #333;">Migrate SMRS Rates Brand LK to LFC</h3>
    <p style="color: #555; margin-bottom: 15px;">Update all SMRS rate records in the database with brand "LK" to "LFC".
    </p>

    <button (click)="updateSmrsRatesBrandLkToLfc()" [disabled]="isUpdatingSmrsRatesBrand"
      style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #ffc107; color: #333; font-weight: bold; border: none; border-radius: 4px;">
      <span *ngIf="isUpdatingSmrsRatesBrand">Updating...</span>
      <span *ngIf="!isUpdatingSmrsRatesBrand">Migrate Rates LK to LFC</span>
    </button>
  </div>

  <div class="tool-card"
    style="border: 1px solid #ddd; border-radius: 8px; padding: 20px; background-color: #f9f9f9; max-width: 600px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); margin-top: 20px;">
    <h3 style="margin-top: 0; color: #333;">Migrate Brands Names to IDs</h3>
    <p style="color: #555; margin-bottom: 15px;">Update 'company' and 'smrs_rates' collections to use brand IDs instead
      of brand names.</p>

    <button (click)="migrateBrandsToIds()" [disabled]="isMigratingBrands"
      style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #e83e8c; color: white; font-weight: bold; border: none; border-radius: 4px;">
      <span *ngIf="isMigratingBrands">Migrating...</span>
      <span *ngIf="!isMigratingBrands">Migrate Brand Names to IDs</span>
    </button>
  </div>

  <div class="tool-card"
    style="border: 1px solid #ddd; border-radius: 8px; padding: 20px; background-color: #f9f9f9; max-width: 600px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); margin-top: 20px;">
    <h3 style="margin-top: 0; color: #333;">Cross-Account Data Migration</h3>
    <p style="color: #555; margin-bottom: 15px;">Copy a collection from another Firebase project into this one.</p>

    <div style="margin-bottom: 15px;">
      <label style="display: block; margin-bottom: 5px; font-weight: bold; color: #555;">Source Firebase Config
        (JSON):</label>
      <textarea [(ngModel)]="firebasePhotoLavie" placeholder='{"apiKey": "...", "authDomain": "...", ...}'
        style="width: 100%; height: 100px; padding: 8px; border: 1px solid #ccc; border-radius: 4px; box-sizing: border-box; font-family: monospace; resize: vertical;"></textarea>
    </div>

    <div style="margin-bottom: 15px;">
      <label style="display: block; margin-bottom: 5px; font-weight: bold; color: #555;">Collection Name:</label>
      <input type="text" [(ngModel)]="migrationCollection" placeholder="e.g., products"
        style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px; box-sizing: border-box;">
    </div>

    <button (click)="migrateCollection()"
      style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #dc3545; color: white; border: none; border-radius: 4px;">
      Migrate Collection
    </button>
  </div>

  <div class="tool-card"
    style="border: 1px solid #ddd; border-radius: 8px; padding: 20px; background-color: #f9f9f9; margin-top: 20px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
    <h3 style="margin-top: 0; color: #333;">PhotoLavie Machines Grid</h3>
    <p style="color: #555; margin-bottom: 15px;">Fetch and display all documents from the 'machines' collection in
      PhotoLavie.</p>

    <button (click)="fetchMachines()" [disabled]="isLoadingMachines"
      style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #007bff; color: white; border: none; border-radius: 4px;">
      {{ isLoadingMachines ? 'Loading...' : 'Load Machines' }}
    </button>

    <div *ngIf="machines.length > 0" style="margin-top: 20px; overflow-x: auto;">
      <table style="width: 100%; border-collapse: collapse; background-color: white; font-size: 12px;">
        <thead>
          <tr style="background-color: #e9ecef;">
            <th style="padding: 8px; border: 1px solid #dee2e6; text-align: left;">ID</th>
            <th style="padding: 8px; border: 1px solid #dee2e6; text-align: left;">Data</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let machine of machines">
            <td style="padding: 8px; border: 1px solid #dee2e6; font-weight: bold; vertical-align: top;">{{ machine.id
              }}</td>
            <td style="padding: 8px; border: 1px solid #dee2e6;">
              <pre style="margin: 0; white-space: pre-wrap;">{{ machine | json }}</pre>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="tool-card"
    style="border: 1px solid #ddd; border-radius: 8px; padding: 20px; background-color: #f9f9f9; max-width: 600px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); margin-top: 20px;">
    <h3 style="margin-top: 0; color: #333;">Populate Stores from Machines</h3>
    <p style="color: #555; margin-bottom: 15px;">Fetch machines from PhotoLavie and populate the local 'stores'
      collection with unique stores.</p>

    <div style="display: flex; gap: 10px;">
      <button (click)="populateStoresFromMachines()" [disabled]="isPopulatingStores"
        style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #20c997; color: white; border: none; border-radius: 4px;">
        <span *ngIf="isPopulatingStores">Populating...</span>
        <span *ngIf="!isPopulatingStores">Populate Stores</span>
      </button>

      <button (click)="deletePopulatedStores()" [disabled]="isDeletingStores"
        style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #dc3545; color: white; border: none; border-radius: 4px;">
        <span *ngIf="isDeletingStores">Deleting...</span>
        <span *ngIf="!isDeletingStores">Delete Added Stores</span>
      </button>
    </div>
  </div>

  <div class="tool-card"
    style="border: 1px solid #ddd; border-radius: 8px; padding: 20px; background-color: #f9f9f9; max-width: 600px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); margin-top: 20px;">
    <h3 style="margin-top: 0; color: #333;">Migrate Paid Invoices to Money Market</h3>
    <p style="color: #555; margin-bottom: 15px;">For the specified period, this tool deletes all existing SMRS money
      market transfers and re-transfers amounts from all paid invoices.</p>

    <div style="margin-bottom: 15px;">
      <label style="display: block; margin-bottom: 5px; font-weight: bold; color: #555;">Period (YYYY/MM):</label>
      <input type="text" [(ngModel)]="migrationPeriodMM" (ngModelChange)="onMigrationPeriodChange()"
        placeholder="e.g., 2024/05"
        style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px; box-sizing: border-box;">
    </div>

    <button (click)="previewPaidInvoicesToMM()" [disabled]="isPreviewingMM"
      style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #0d6efd; color: white; border: none; border-radius: 4px; margin-right: 10px;">
      <span *ngIf="isPreviewingMM">Loading...</span>
      <span *ngIf="!isPreviewingMM">Preview Migration</span>
    </button>

    <button *ngIf="migrationPreviewMM.length > 0" (click)="migratePaidInvoicesToMM()" [disabled]="isMigratingMM"
      style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #198754; color: white; border: none; border-radius: 4px;">
      <span *ngIf="isMigratingMM">Migrating...</span>
      <span *ngIf="!isMigratingMM">Confirm & Migrate</span>
    </button>

    <div *ngIf="hasPreviewedMM" style="margin-top: 15px;">
      <p *ngIf="migrationPreviewMM.length === 0" style="color: #dc3545;">No invoices to migrate for this period.</p>
      <div *ngIf="migrationPreviewMM.length > 0">
        <p style="font-weight: bold;">Invoices to be migrated ({{ migrationPreviewMM.length }}):</p>
        <table style="width: 100%; border-collapse: collapse; margin-top: 10px; font-size: 14px;">
          <thead>
            <tr style="background-color: #f1f1f1;">
              <th style="padding: 8px; border: 1px solid #ddd; text-align: left;">Company</th>
              <th style="padding: 8px; border: 1px solid #ddd; text-align: right;">Current Period ({{ migrationPeriodMM
                }})</th>
              <th style="padding: 8px; border: 1px solid #ddd; text-align: right;">Previous Balance</th>
              <th style="padding: 8px; border: 1px solid #ddd; text-align: right;">Total Transfer (USD)</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of migrationPreviewMM">
              <td style="padding: 8px; border: 1px solid #ddd;">
                {{ item.companyName }}
                <div *ngIf="item.previousAmount > 0" style="font-size: 11px; color: #666;">
                  Prev Period: {{ item.previousPeriod }}
                </div>
              </td>
              <td style="padding: 8px; border: 1px solid #ddd; text-align: right;">{{ item.currentAmount |
                currency:item.currency }}</td>
              <td style="padding: 8px; border: 1px solid #ddd; text-align: right;">{{ item.previousAmount |
                currency:item.currency }}</td>
              <td style="padding: 8px; border: 1px solid #ddd; text-align: right;">{{ item.amountUSD | currency:'USD' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="tool-card"
    style="border: 1px solid #ddd; border-radius: 8px; padding: 20px; background-color: #f9f9f9; max-width: 600px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); margin-top: 20px;">
    <h3 style="margin-top: 0; color: #333;">Reset SMRS Invoice Balance & Status</h3>
    <p style="color: #555; margin-bottom: 15px;">Set the remaining balance to 0 and status to "Not Paid" for SMRS
      invoices in a given period range.</p>

    <div style="display: flex; gap: 10px; margin-bottom: 15px;">
      <div style="flex: 1;">
        <label style="display: block; margin-bottom: 5px; font-weight: bold; color: #555;">Brand:</label>
        <select [(ngModel)]="resetSmrsBrandId"
          style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px; box-sizing: border-box; font-size: 14px; appearance: auto; background-color: white;">
          <option value="">All Brands</option>
          <option *ngFor="let brand of brands" [value]="brand.id">{{ brand.name }}</option>
        </select>
      </div>
      <div style="flex: 1;">
        <label style="display: block; margin-bottom: 5px; font-weight: bold; color: #555;">Company:</label>
        <select [(ngModel)]="resetSmrsCompanyId" (change)="onResetSmrsCompanySelected()"
          style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px; box-sizing: border-box; font-size: 14px; appearance: auto; background-color: white;">
          <option value="" disabled selected>Select Company</option>
          <option *ngFor="let company of filteredResetCompanies" [value]="company.id">{{ company.company }}</option>
        </select>
      </div>
      <div style="flex: 1;">
        <label style="display: block; margin-bottom: 5px; font-weight: bold; color: #555;">Start Period
          (YYYY/MM):</label>
        <input type="text" [(ngModel)]="resetSmrsStartPeriod" placeholder="e.g., 2024/01"
          style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px; box-sizing: border-box;">
      </div>
      <div style="flex: 1;">
        <label style="display: block; margin-bottom: 5px; font-weight: bold; color: #555;">End Period (YYYY/MM):</label>
        <input type="text" [(ngModel)]="resetSmrsEndPeriod" placeholder="e.g., 2024/05"
          style="width: 100%; padding: 8px; border: 1px solid #ccc; border-radius: 4px; box-sizing: border-box;">
      </div>
    </div>

    <button (click)="resetSmrsInvoices()" [disabled]="isResettingSmrs"
      style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #dc3545; color: white; border: none; border-radius: 4px;">
      <span *ngIf="isResettingSmrs">Resetting...</span>
      <span *ngIf="!isResettingSmrs">Reset SMRS Invoices</span>
    </button>
  </div>

  <div class="tool-card"
    style="border: 1px solid #ddd; border-radius: 8px; padding: 20px; background-color: #f9f9f9; max-width: 600px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); margin-top: 20px;">
    <h3 style="margin-top: 0; color: #333;">Cleanup _PP Images</h3>
    <p style="color: #555; margin-bottom: 15px;">Scans the Photobooth storage folder recursively and deletes all images
      ending with "_PP" (e.g. portal images).</p>

    <button (click)="scanPPImages()" [disabled]="isScanningPP || isCleaningPPImages"
      style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #dc3545; color: white; border: none; border-radius: 4px;">
      <span *ngIf="isScanningPP">Scanning Storage...</span>
      <span *ngIf="isCleaningPPImages">Deleting...</span>
      <span *ngIf="!isScanningPP && !isCleaningPPImages">Scan and Delete _PP Images</span>
    </button>
  </div>
  <div class="tool-card"
    style="border: 1px solid #ddd; border-radius: 8px; padding: 20px; background-color: #f9f9f9; max-width: 600px; box-shadow: 0 2px 4px rgba(0,0,0,0.1); margin-top: 20px;">
    <h3 style="margin-top: 0; color: #333;">List Claimed Sessions</h3>
    <p style="color: #555; margin-bottom: 15px;">Query the entire database for sessions that have been claimed by a user
      (has emails in claimedByEmails).</p>

    <button (click)="fetchClaimedSessions()" [disabled]="isFetchingClaimedSessions"
      style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #20c997; color: white; border: none; border-radius: 4px; margin-bottom: 15px;">
      <span *ngIf="isFetchingClaimedSessions">Fetching...</span>
      <span *ngIf="!isFetchingClaimedSessions">Get Claimed Sessions</span>
    </button>

    <div *ngIf="claimedSessions.length > 0"
      style="margin-top: 15px; padding: 10px; background-color: white; border: 1px solid #eee; border-radius: 4px; max-height: 400px; overflow-y: auto;">
      <h4 style="margin-top: 0; margin-bottom: 10px; font-size: 14px; color: #333;">Found {{ claimedSessions.length }}
        Sessions:</h4>
      <div *ngFor="let session of claimedSessions"
        style="margin-bottom: 15px; padding-bottom: 10px; border-bottom: 1px solid #eee;">
        <div style="font-size: 14px; font-weight: bold; color: #333;">{{ session.date }}</div>
        <div style="font-size: 13px; color: #555;"><strong>User:</strong> {{ session.emails }}</div>
        <div style="font-size: 13px; color: #555;"><strong>Device:</strong> {{ session.deviceId }}</div>
        <div style="font-size: 11px; color: #888; font-family: monospace;">Session ID: {{ session.sessionId }}</div>
      </div>
    </div>
    <div *ngIf="claimedSessions.length === 0 && !isFetchingClaimedSessions" style="font-size: 13px; color: #888;">
      No claimed sessions loaded.
    </div>
  </div>

  <!-- SMRS Invoice Ledger Integrity & Migration -->
  <div class="ledger-tool-card">
    <h3 class="ledger-tool-title">SMRS Invoice Ledger Integrity & Migration (Company-by-Company)</h3>
    <p class="ledger-tool-desc">
      Select a company to audit its complete period history in the <code>invoices</code> collection. Review currently stored numbers against projected forward calculations from monthly aggregations, inspect any missing fields, and safely migrate that company's invoice collection with locked payment guarantees.
    </p>

    <!-- Company and Brand Selection Row -->
    <div class="ledger-filter-row">
      <div class="ledger-filter-group">
        <label class="ledger-filter-label">Filter by Brand:</label>
        <select [(ngModel)]="ledgerMigrationBrandId" (ngModelChange)="onLedgerBrandChange()" class="ledger-filter-select">
          <option value="">All Brands</option>
          <option *ngFor="let b of brands" [value]="b.id">{{ b.name }}</option>
        </select>
      </div>

      <div class="ledger-filter-group">
        <label class="ledger-filter-label">Select Target Company <span style="color: #dc3545;">*</span>:</label>
        <select [(ngModel)]="ledgerMigrationCompanyId" (ngModelChange)="onLedgerCompanyChange()" class="ledger-filter-select">
          <option value="" disabled selected>-- Select a Company to Audit & Migrate --</option>
          <option *ngFor="let c of ledgerMigrationCompanies" [value]="c.id">{{ c.company }}</option>
        </select>
      </div>
    </div>

    <!-- Selected Company Info Banner -->
    <div *ngIf="selectedLedgerCompany" class="ledger-selected-company-banner">
      <div>
        <strong>Company:</strong> {{ selectedLedgerCompany.company }} 
        <span *ngIf="selectedLedgerCompany.isFeeCollection" class="badge-missing" style="margin-left: 8px;">Fee Collection</span>
        <span style="margin-left: 12px; color: #555;">ID: <code>{{ selectedLedgerCompany.id }}</code></span>
      </div>
      <div>
        <span *ngIf="hasPreviewedLedger" style="font-weight: bold;">{{ ledgerAuditRows.length }} periods scanned</span>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="ledger-actions">
      <!-- Individual Company Actions -->
      <button (click)="previewInvoiceLedgerRecalculation()" 
        [disabled]="!ledgerMigrationCompanyId || isScanningLedger || isRecalculatingLedger || isBatchScanning || isBatchMigrating"
        class="btn-ledger-scan">
        <span *ngIf="isScanningLedger">Scanning Invoices...</span>
        <span *ngIf="!isScanningLedger">🔍 1. Scan & Audit Company Periods</span>
      </button>

      <button *ngIf="hasPreviewedLedger" (click)="executeInvoiceLedgerMigration()"
        [disabled]="isRecalculatingLedger || isScanningLedger || isBatchScanning || isBatchMigrating || ledgerAuditRows.length === 0" 
        class="btn-ledger-execute">
        <span *ngIf="isRecalculatingLedger">Recalculating & Writing...</span>
        <span *ngIf="!isRecalculatingLedger">⚡ 2. Migrate Invoices for {{ selectedLedgerCompany?.company || 'Company' }}</span>
      </button>

      <!-- Batch Loop Across All Companies in Filter -->
      <button (click)="batchScanCompaniesWithDiscrepancies()"
        [disabled]="isScanningLedger || isRecalculatingLedger || isBatchScanning || isBatchMigrating"
        class="btn-ledger-batch-scan">
        <span *ngIf="isBatchScanning">Scanning All Companies...</span>
        <span *ngIf="!isBatchScanning">🔄 Batch Scan All Companies in Scope</span>
      </button>

      <button *ngIf="companiesWithDiscrepancies.length > 0" (click)="executeBatchMigrationInLoop()"
        [disabled]="isScanningLedger || isRecalculatingLedger || isBatchScanning || isBatchMigrating"
        class="btn-ledger-batch-execute">
        <span *ngIf="isBatchMigrating">Migrating Companies in Loop...</span>
        <span *ngIf="!isBatchMigrating">🚀 Migrate {{ companiesWithDiscrepancies.length }} Companies With Discrepancies</span>
      </button>
    </div>

    <!-- Batch Loop Live Progress Banner -->
    <div *ngIf="isBatchScanning || isBatchMigrating" class="ledger-batch-progress-box">
      <div style="font-weight: 600;">{{ batchProgressText }}</div>
      <div class="ledger-batch-progress-bar">
        <div class="ledger-batch-progress-fill" [style.width.%]="batchProgressPercent"></div>
      </div>
    </div>

    <!-- Stats Banner -->
    <div *ngIf="hasPreviewedLedger" class="ledger-stats-banner">
      <div class="ledger-stat-item">
        <span class="ledger-stat-val">{{ ledgerMigrationStats.totalChecked }}</span>
        <span class="ledger-stat-lbl">Periods Audited</span>
      </div>
      <div class="ledger-stat-item">
        <span class="ledger-stat-val"
          [ngClass]="{'highlight-danger': ledgerMigrationStats.missingInvoicesCount > 0, 'highlight-ok': ledgerMigrationStats.missingInvoicesCount === 0}">
          {{ ledgerMigrationStats.missingInvoicesCount }}
        </span>
        <span class="ledger-stat-lbl">Missing Invoice Docs</span>
      </div>
      <div class="ledger-stat-item">
        <span class="ledger-stat-val"
          [ngClass]="{'highlight-warn': ledgerMigrationStats.totalPopulated > 0, 'highlight-ok': ledgerMigrationStats.totalPopulated === 0}">
          {{ ledgerMigrationStats.totalPopulated }}
        </span>
        <span class="ledger-stat-lbl">Docs with Missing Fields</span>
      </div>
      <div class="ledger-stat-item">
        <span class="ledger-stat-val"
          [ngClass]="{'highlight-danger': ledgerMigrationStats.totalDiscrepancies > 0, 'highlight-ok': ledgerMigrationStats.totalDiscrepancies === 0}">
          {{ ledgerMigrationStats.totalDiscrepancies }}
        </span>
        <span class="ledger-stat-lbl">Balance Discrepancies</span>
      </div>
    </div>

    <!-- Perfect Sync Notification when totalChecked > 0 and no diffs -->
    <div *ngIf="hasPreviewedLedger && ledgerMigrationStats.totalChecked > 0 && ledgerMigrationStats.totalDiscrepancies === 0 && ledgerMigrationStats.totalPopulated === 0 && ledgerMigrationStats.missingInvoicesCount === 0" class="ledger-all-good-box">
      <span>✓ All {{ ledgerMigrationStats.totalChecked }} periods for {{ selectedLedgerCompany?.company }} are in perfect mathematical sync with monthly store aggregations and forward ledger rules!</span>
    </div>

    <!-- Companies with Discrepancies Summary (from Batch Scan) -->
    <div *ngIf="companiesWithDiscrepancies.length > 0" class="ledger-batch-queue-container" style="background: #fff; border: 1px solid #fed7aa; border-radius: 6px; padding: 14px; margin-bottom: 16px;">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
        <h4 style="margin: 0; color: #c2410c; font-size: 14px; font-weight: 700;">
          ⚠️ {{ companiesWithDiscrepancies.length }} Companies Ready for Migration Loop:
        </h4>
        <span style="font-size: 12px; color: #7c2d12;">Click "Migrate Companies With Discrepancies" above to process</span>
      </div>
      <div style="max-height: 200px; overflow-y: auto;">
        <table style="width: 100%; border-collapse: collapse; font-size: 12px;">
          <thead>
            <tr style="background-color: #fff7ed; border-bottom: 1px solid #fed7aa; text-align: left;">
              <th style="padding: 6px 10px;">Company</th>
              <th style="padding: 6px 10px;">Earliest Period</th>
              <th style="padding: 6px 10px; text-align: right;">Total Periods</th>
              <th style="padding: 6px 10px; text-align: right;">Discrepant Periods</th>
              <th style="padding: 6px 10px; text-align: right;">Missing Docs/Fields</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of companiesWithDiscrepancies" style="border-bottom: 1px solid #ffedd5;">
              <td style="padding: 6px 10px; font-weight: 600; color: #333;">{{ item.companyName }}</td>
              <td style="padding: 6px 10px; font-family: monospace;">{{ item.earliestPeriod }}</td>
              <td style="padding: 6px 10px; text-align: right;">{{ item.totalPeriods }}</td>
              <td style="padding: 6px 10px; text-align: right; font-weight: bold; color: #dc3545;">{{ item.discrepancyCount }}</td>
              <td style="padding: 6px 10px; text-align: right; color: #e0a800;">{{ item.missingCount }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Detailed Side-by-Side Audit & Migration Table -->
    <div *ngIf="hasPreviewedLedger && ledgerAuditRows.length > 0" class="ledger-diff-container">
      <table class="ledger-diff-table">
        <thead>
          <tr>
            <th rowspan="2" style="vertical-align: bottom;">Period</th>
            <th colspan="5" class="th-group-current">Currently Stored in Firestore (invoices)</th>
            <th rowspan="2" class="th-group-status" style="vertical-align: bottom;">Missing / Status</th>
            <th colspan="5" class="th-group-projected">Projected Values to be Updated (After Migration)</th>
          </tr>
          <tr>
            <!-- Current Stored Columns -->
            <th style="text-align: right;">Beg. Bal</th>
            <th style="text-align: right;">Total Fee</th>
            <th style="text-align: right;">Total Due</th>
            <th style="text-align: right;">Paid (Locked)</th>
            <th style="text-align: right;" class="ledger-border-right">Rem. Bal</th>

            <!-- Projected Columns -->
            <th style="text-align: right;">Beg. Bal</th>
            <th style="text-align: right;">Total Fee</th>
            <th style="text-align: right;">Total Due</th>
            <th style="text-align: right;">Paid (Locked)</th>
            <th style="text-align: right;">Rem. Bal</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of ledgerAuditRows"
            [ngClass]="{
              'ledger-diff-row-danger': row.diffFound && !row.hasExistingDoc,
              'ledger-diff-row-warn': row.diffFound && row.hasExistingDoc,
              'ledger-diff-row-ok': !row.diffFound && row.missingFields.length === 0
            }">
            <!-- Period -->
            <td><strong>{{ row.period }}</strong></td>

            <!-- Current Stored State -->
            <td class="ledger-num" [ngClass]="{'ledger-val-missing': row.currentBeg === null}">
              {{ row.currentBeg !== null ? (row.currentBeg | currency) : 'Missing' }}
            </td>
            <td class="ledger-num" [ngClass]="{'ledger-val-missing': row.currentFee === null}">
              {{ row.currentFee !== null ? (row.currentFee | currency) : 'Missing' }}
            </td>
            <td class="ledger-num" [ngClass]="{'ledger-val-missing': row.currentDue === null}">
              {{ row.currentDue !== null ? (row.currentDue | currency) : 'Missing' }}
            </td>
            <td class="ledger-num">
              {{ row.currentPaid | currency }}
            </td>
            <td class="ledger-num ledger-border-right" [ngClass]="{'ledger-val-missing': row.currentRem === null}">
              {{ row.currentRem !== null ? (row.currentRem | currency) : 'Missing' }}
            </td>

            <!-- Status / Diagnosis Badges -->
            <td style="text-align: center;">
              <div *ngIf="!row.hasExistingDoc">
                <span class="badge-diff">Doc Missing</span>
              </div>
              <div *ngIf="row.hasExistingDoc && row.missingFields.length > 0" style="margin-bottom: 3px;">
                <span *ngFor="let f of row.missingFields" class="badge-missing">{{ f }}</span>
              </div>
              <div *ngIf="row.hasExistingDoc && row.diffFound">
                <span class="badge-diff">Discrepancy</span>
              </div>
              <div *ngIf="row.hasExistingDoc && !row.diffFound && row.missingFields.length === 0">
                <span class="badge-ok">✓ In Sync</span>
              </div>
            </td>

            <!-- Projected Values -->
            <td class="ledger-num" [ngClass]="{'ledger-val-changed': row.begDiff}">
              {{ row.projectedBeg | currency }}
            </td>
            <td class="ledger-num" [ngClass]="{'ledger-val-changed': row.feeDiff}">
              {{ row.projectedFee | currency }}
            </td>
            <td class="ledger-num" [ngClass]="{'ledger-val-changed': row.dueDiff}">
              {{ row.projectedDue | currency }}
            </td>
            <td class="ledger-num" style="color: #198754; font-weight: 600;">
              {{ row.projectedPaid | currency }}
            </td>
            <td class="ledger-num" [ngClass]="{'ledger-val-changed': row.remDiff}">
              <strong>{{ row.projectedRem | currency }}</strong>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Realtime Execution Terminal Logs -->
    <div *ngIf="ledgerMigrationLogs.length > 0" class="ledger-logs-box">
      <div *ngFor="let log of ledgerMigrationLogs" class="ledger-log-entry">{{ log }}</div>
    </div>
  </div>

  <!-- Master Data Migration (Company, Store, Device & Relationships) -->
  <div class="tool-card master-data-card">
    <h3 class="master-data-title">Master Data Migration (Company, Store, Device & Relationships)</h3>

    <div class="master-data-description">
      <p>
        <strong>Production to Dev Migration Tool:</strong> Export all master entities (Companies, Stores, Devices,
        Company Ownerships, Owners, and Brands) into a structured JSON backup, and import that package into Firestore
        with 100% relational integrity preserved.
      </p>
    </div>

    <div class="master-data-actions">
      <!-- Export Button -->
      <button (click)="exportMasterData()" [disabled]="isExportingMasterData || isImportingMasterData || isRemappingBrands"
        class="btn-export-master">
        <span *ngIf="isExportingMasterData">Exporting Data...</span>
        <span *ngIf="!isExportingMasterData">📥 Export Master Data (.json)</span>
      </button>

      <!-- Import Trigger Button -->
      <input type="file" #masterDataFileInput class="hidden-file-input" (change)="onMasterDataFileSelected($event)"
        accept=".json">
      <button (click)="masterDataFileInput.click()" [disabled]="isExportingMasterData || isImportingMasterData || isRemappingBrands"
        class="btn-import-master">
        <span>📤 Select JSON to Import</span>
      </button>

      <!-- Remap Brands Button -->
      <button (click)="remapBrandsToExistingIds()" [disabled]="isExportingMasterData || isImportingMasterData || isRemappingBrands"
        class="btn-remap-master">
        <span *ngIf="isRemappingBrands">Remapping Brands...</span>
        <span *ngIf="!isRemappingBrands">🔄 Remap Brands to Existing IDs</span>
      </button>
    </div>

    <!-- Preview of Selected Import File -->
    <div *ngIf="masterDataImportStats" class="master-preview-section">
      <div class="master-preview-header">
        <h4 class="master-preview-title">Ready to Import: {{ masterDataImportFileName }}</h4>
        <button (click)="cancelMasterDataImport()" class="btn-cancel-import"
          [disabled]="isImportingMasterData">Cancel</button>
      </div>

      <div class="master-preview-grid">
        <div class="master-stat-box master-stat-box-mapped">
          <span class="master-stat-num">{{ masterDataImportStats.brands }}</span>
          <span class="master-stat-label">Brands (Mapped)</span>
        </div>
        <div class="master-stat-box">
          <span class="master-stat-num">{{ masterDataImportStats.owners }}</span>
          <span class="master-stat-label">Owners</span>
        </div>
        <div class="master-stat-box">
          <span class="master-stat-num">{{ masterDataImportStats.companies }}</span>
          <span class="master-stat-label">Companies</span>
        </div>
        <div class="master-stat-box">
          <span class="master-stat-num">{{ masterDataImportStats.stores }}</span>
          <span class="master-stat-label">Stores</span>
        </div>
        <div class="master-stat-box">
          <span class="master-stat-num">{{ masterDataImportStats.devices }}</span>
          <span class="master-stat-label">Devices</span>
        </div>
        <div class="master-stat-box">
          <span class="master-stat-num">{{ masterDataImportStats.companyOwnerships }}</span>
          <span class="master-stat-label">Ownerships</span>
        </div>
      </div>

      <div class="master-confirm-actions">
        <button (click)="executeMasterDataImport()" [disabled]="isImportingMasterData" class="btn-execute-master">
          <span *ngIf="isImportingMasterData">Writing to Firestore...</span>
          <span *ngIf="!isImportingMasterData">⚡ Execute Import into Firestore</span>
        </button>
      </div>
    </div>

    <!-- Live Telemetry / Migration Logs -->
    <div *ngIf="masterDataLogs.length > 0" class="master-logs-box">
      <div *ngFor="let log of masterDataLogs" class="master-log-entry">{{ log }}</div>
    </div>
  </div>

  <!-- Coupon brand migration (KAN-230) -->
  <div class="coupon-migration-card">
    <h3 class="coupon-migration-title">🎟️ Assign Every Coupon to K-Photo LaVie</h3>
    <p class="coupon-migration-desc">
      Sets <code>applicableBrands</code> to the K-Photo LaVie brand on <strong>every</strong> document in <code>coupons</code>
      (active, redeemed, revoked, expired, inactive and soft-deleted), including coupons currently scoped to Konobox or All brands.
      Only that one field changes. Nothing runs automatically: preview first, then confirm the environment.
    </p>

    <div class="coupon-migration-actions">
      <button type="button" class="coupon-migration-btn" (click)="previewCouponBrandMigration()" [disabled]="isScanningCoupons || isApplyingCouponMigration">
        <span *ngIf="isScanningCoupons">Scanning coupons...</span>
        <span *ngIf="!isScanningCoupons">1. Preview (read-only)</span>
      </button>
    </div>

    <div *ngIf="couponMigrationProjectId" class="coupon-migration-env" role="status">
      Environment: <strong>{{ couponMigrationProjectId }}</strong>
      <ng-container *ngIf="couponMigrationBrand?.status === 'ok'">
        · Target brand: <strong>{{ $any(couponMigrationBrand).brandName }}</strong> ({{ $any(couponMigrationBrand).brandId }})
      </ng-container>
    </div>

    <div *ngIf="couponMigrationBrand && couponMigrationBrand.status !== 'ok'" class="coupon-migration-blocked" role="alert">
      {{ $any(couponMigrationBrand).message }}
    </div>

    <ng-container *ngIf="couponMigrationPlan as plan">
      <div class="coupon-migration-stats">
        <div class="coupon-migration-stat"><span class="num">{{ plan.total }}</span><span class="lbl">Coupons scanned</span></div>
        <div class="coupon-migration-stat"><span class="num">{{ plan.toUpdate }}</span><span class="lbl">Will be updated</span></div>
        <div class="coupon-migration-stat"><span class="num">{{ plan.toSkip }}</span><span class="lbl">Already correct</span></div>
        <div class="coupon-migration-stat"><span class="num">{{ plan.softDeleted }}</span><span class="lbl">Soft-deleted</span></div>
      </div>
      <div class="coupon-migration-status-row">
        <span *ngFor="let s of couponMigrationStatusRows" class="coupon-migration-chip">{{ s.status }}: {{ s.count }}</span>
      </div>

      <div class="data-grid-scrollable coupon-migration-table-wrap">
        <table class="coupon-migration-table">
          <thead><tr><th>Coupon</th><th>Status</th><th>Before</th><th>After</th><th>Action</th></tr></thead>
          <tbody>
            <tr *ngFor="let r of plan.rows | slice:0:200">
              <td>{{ r.id }}<span *ngIf="r.isDeleted" class="coupon-migration-deleted"> (deleted)</span></td>
              <td>{{ r.status }}</td>
              <td>{{ r.before.length ? r.before.join(', ') : '(not set)' }}</td>
              <td>{{ r.after.join(', ') }}</td>
              <td [class.coupon-migration-skip]="r.action === 'skip'">{{ r.action }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p *ngIf="plan.total > 200" class="coupon-migration-note">Showing the first 200 of {{ plan.total }} coupons; the snapshot download at apply time lists all of them.</p>

      <div *ngIf="plan.toUpdate > 0 && couponMigrationBrand?.status === 'ok'" class="coupon-migration-confirm">
        <label for="couponMigrationProject">
          Type the environment <strong>{{ couponMigrationProjectId }}</strong> to confirm updating
          <strong>{{ plan.toUpdate }}</strong> coupons to <strong>{{ $any(couponMigrationBrand).brandName }}</strong>:
        </label>
        <input id="couponMigrationProject" type="text" class="coupon-migration-input" autocomplete="off"
          [(ngModel)]="couponMigrationTypedProject" [disabled]="isApplyingCouponMigration" />
        <button type="button" class="coupon-migration-btn coupon-migration-btn-danger" (click)="executeCouponBrandMigration()"
          [disabled]="!couponMigrationConfirmed || isApplyingCouponMigration">
          <span *ngIf="isApplyingCouponMigration">Updating... {{ couponMigrationProgress }}</span>
          <span *ngIf="!isApplyingCouponMigration">2. Apply to {{ plan.toUpdate }} coupons</span>
        </button>
      </div>
      <p *ngIf="plan.toUpdate === 0" class="coupon-migration-done" role="status">Every coupon already has the target scope. Nothing to do.</p>
    </ng-container>

    <div *ngIf="couponMigrationOutcome as o" class="coupon-migration-outcome" role="status">
      Updated {{ o.updated.length }} · Skipped {{ o.skipped.length }} · Failed {{ o.failed.length }}
      <ul *ngIf="o.failed.length > 0" class="coupon-migration-failed">
        <li *ngFor="let f of o.failed | slice:0:50">{{ f.id }}: {{ f.error }}</li>
      </ul>
    </div>

    <div *ngIf="couponMigrationLogs.length > 0" class="coupon-migration-logs">
      <div *ngFor="let log of couponMigrationLogs">{{ log }}</div>
    </div>
  </div>

</div>